import useQueryParams from './queryParams'

const useCurrentPath = (): string | null => {
  const query = useQueryParams()
  return query.get('path')
}

export default useCurrentPath
